import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import { today } from '@internationalized/date';

import { Button, Menu, cn } from '@simplywallst/ui-core/next';

export type PresetDateOption =
  | 'inception'
  | '4w'
  | '3m'
  | '1y'
  | 'ytd'
  | '1yago'
  | '2yago'
  | 'custom';

const options: {
  option: PresetDateOption;
  label: string;
}[] = [
  { option: 'inception', label: 'Since inception' },
  { option: '4w', label: 'Last 4 weeks' },
  { option: '3m', label: 'Last 3 Months' },
  { option: '1y', label: 'Last 12 months' },
  { option: 'ytd', label: 'Year to date' },
  {
    option: '1yago',
    label: `${today('UTC').year - 1}`,
  },
  {
    option: '2yago',
    label: `${today('UTC').year - 2}`,
  },
  { option: 'custom', label: 'Custom' },
];

type Props = {
  isDisabled?: boolean;
  selected: PresetDateOption;
  setSelected: (option: PresetDateOption) => void;
};

export const DateMenu = ({ isDisabled, selected, setSelected }: Props) => {
  return (
    <div className="flex">
      <Menu
        label={
          <Button
            variant="outline"
            isDisabled={isDisabled}
            className={cn(
              selected === 'custom' ? 'flex-1 justify-between' : ''
            )}
          >
            {options.find((option) => option.option === selected)?.label ?? ''}
            <ChevronDownSmallSolid />
          </Button>
        }
      >
        {options.map((option) => (
          <Menu.Item
            onAction={() => setSelected(option.option)}
            textValue={option.label}
            key={option.option}
          >
            {option.label}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
};
